import Search from "../../components/form/Search";
import Container from "../../components/shared/Container";
import { Link, useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Button from "../../components/form/Button";
import Dropdown from "../../components/form/Dropdown";
import Image from "../../components/elements/Image";
import { useEffect, useState } from "react";
import { classNames } from "../../helpers/classNames";
import { AnimatePresence, motion } from "motion/react";
import { lngDetect } from "../../helpers/lngDetect";
import { changeOrganization } from "../../services/organizationService";
import { useDispatch } from "react-redux";
import { resetOrganization, setOrganization } from "../../redux/slice/organizationSlice";
import { useMutation } from "@tanstack/react-query";
import useFindRoute from "../../hooks/useFindRoute";
import LogoutModal from "../../components/LogoutModal/LogoutModal";
import Indentification from "../../components/elements/Indentification";
import { initialsValue } from "../../helpers";

const AdminHeader = ({ profile, organizer }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const { matchedRoute, replaceParams } = useFindRoute();
  const navigate = useNavigate();
  const location = useLocation();
  const { session } = useSelector((state) => state?.authProvider);
  const { lang } = useSelector((state) => state?.langProvider);
  const [isSideMenu, setSideMenu] = useState(false);
  const { appliedTheme, selectedElement, status } = useSelector((state) => state?.themeProvider);
  const user = useSelector((state) => state?.profile);
  const [isLogoutModelOpen, setIsLogOutModelOpen] = useState(false);

  useEffect(() => {
    const html = document.querySelector("html");
    if (isSideMenu) {
      html.style.overflow = "hidden";
      html.style.paddingRight = "17px";
    } else {
      html.style.overflow = "";
      html.style.paddingRight = "";
    }
  }, [isSideMenu]);

  useEffect(() => {
    setSideMenu(false);
  }, [location]);

  const organizerHeaderStyle = organizer?.data?.data?.themeSetting?.styles?.headerStyle;

  return (
    <>
      <header
        className="header bg-surface-04 w-full sticky top-0 z-50"
        style={organizerHeaderStyle?.background ? { backgroundColor: organizerHeaderStyle?.background } : {}}
      >
        <Container className={"justify-between h-24 items-center max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl gap-6"}>
          <Link className="h-12 max-w-36 xl:max-w-40 2xl:max-w-48" to={"/"} replace>
            <Image
              src={appliedTheme?.logo instanceof File ? URL.createObjectURL(appliedTheme?.logo) : appliedTheme?.logo?.url || appliedTheme?.logo}
              alt={"Logo"}
              classes={"object-contain"}
            />
          </Link>
          <div className="w-80 2xl:w-[410px] mx-auto">{user?.data?.role === "admin" ? "" : <Search divClasses="bg-transparent" />}</div>
          <Link className="h-12 max-w-36 xl:max-w-40 2xl:max-w-48" to={`/${lang}/admin/profile`} replace>
            <Indentification
                  initial={initialsValue(user?.data?.firstName+" "+user?.data?.lastName || "")}
                  fill={true}
                  type="square"
                />
                {/* <i className="w-8 h-8 text-[30px] fas fa-user"></i> */}
          </Link>
          <div
            className="text-purple-900 hover:scale-105 transition-transform duration-200 cursor-pointer inline-flex items-center mb-2"
            onClick={(val) => {
              setIsLogOutModelOpen(true);
            }}
          >
            <i className="fa-regular fa-arrow-right-from-arc"></i>
            <span className="ml-2 font-bold">Log Out</span>
          </div>
        </Container>
      </header>
      <LogoutModal setIsOpen={(val) => setIsLogOutModelOpen(val)} isOpen={isLogoutModelOpen} redirectUrl="/admin/signin" />
    </>
  );
};

export default AdminHeader;
